const axios = require('axios');

class PipelineCrm {
    constructor() {

    }

    static get_pipeline_crm_form() {
        return {
            id: null,
            name: null,
            assigned_users: [],
        }
    }
}

class PipelineTeam {
    constructor() {

    }

    static get_form() {
        return {
            id: null,
            pipeline_user: null,
            pipeline: null,
            notification_bool: false,
            email_bool: false,
        }
    }
}

class StateCrm {
    constructor() {

    }

    static get_state_crm_form() {
        return {
            id: null,
            name: null,
            description: null,
            awarded_in_bool: false,
            awarded_in_type: null,
            awarded_in_number: null,
            order: null,
            pipeline: null,
            probability: 0,
            template: null,
            automation_bool: false
        }
    }

    static get_type_choices() {
        return [
            {text: "Jours", value: "days"},
            {text: "Mois", value: "moths"},
            {text: "Semaines", value: "weaks"},

        ]
    }
}

class BusinessOpportunity {
    constructor() {

    }

    static get_business_opportunity_form() {
        return {
            id: null,
            organization: null,
            contact: null,
            name: null,
            description: null,
            keywords: null,
            phone: null,
            email: null,
            state: null,
            priority: "weak",
            amount: 0,
            probability: 0,
            end_date: null,
            main_user: null,
            assigned_users: [],
            main_user_name: null,
            expected_end_date: null,
            contact_name: null,
            organization_name: null,
            weighting: null,
            is_person: false,
            source: null,
            other_source: null,
            smart_management: false,
            lower_weighting: 0,
            lower_frequency: 30,
            last_management_update: new Date()
        }
    }

    static get_priorities_choices() {
        return [
            {text: "Faible", value: "weak"},
            {text: "Moyenne", value: "medium"},
            {text: "Forte", value: "strong"},
        ]
    }

    static get_status_choices() {
        return [
            {text: "En attente", value: "pending"},
            {text: "Annulé", value: "canceled"},
            {text: "Accepté", value: "accepted"},
        ]
    }


    static get_source_choices() {
        return [
            {text: "Evenement", value: "event"},
            {text: "Lead génération", value: "lead_generation"},
            {text: "Réseau", value: "network"},
            {text: "Affiliation", value: "affiliate"},
            {text: "Email marketing", value: "email_marketing"},
            {text: "Partenaire", value: "partner"},
            {text: "Cooptation", value: "cooptation"},
            {text: "Prospection", value: "prospecting"},
            {text: "Autres sources", value: "other"},
        ]
    }
}

class Quotation {
    constructor() {
      self.name = "Quotation"
    }

    static get_quotation_form() {
        return {
            id: null,
            company: "xxx",
            number: null,
            attention_to: null,
            attention_to_name: null,
            organization: null,
            organization_name: null,
            season: null,
            expiration_days: 30,
            send: false,
            send_date: null,
            taxes: null,
            delivery_taxes: 20,
            delivery_cost: 0,
            phone: null,
            email: null,
            billing_address: null,
            billing_city: null,
            billing_postal_code: null,
            billing_province: null,
            billing_country: null,
            delivery_address: null,
            delivery_city: null,
            delivery_postal_code: null,
            delivery_province: null,
            delivery_country: null,
            discount: null,
            account_manager: null,
            account_manager_name: null,
            terms_of_sales: null,
            total_discount: 0,
            total_quantity: 0,
            total_taxes: 0,
            subtotal: 0,
            total: 0,
            status: "pending",
            delivery_date: null,
            personal_organization_name: null,
            personal_organization_address: null,
            personal_organization_city: null,
            personal_organization_country: null,
            personal_organization_postal_code: null,
            personal_organization_siret: null,
            personal_organization_vat_exemption: false,
            person: false,
            my_organization: true,
            expense: false,
            billing_iban: null,
            billing_bic: null,
            linked_quotations: [],
        }
    }

    static get_season_choices() {
        return [
            {value: "spring", text: "Printemps"},
            {value: "summer", text: "Été"},
            {value: "winter", text: "Hiver"},
            {value: "autumn", text: "Automne"},
        ]
    }

    static get_status_choices() {
        return [
            {text: "En attente", value: "pending"},
            {text: "Annulé", value: "canceled"},
            {text: "Accepté", value: "accepted"},
            {text: "Accepté et transformé", value: "accepted_transformed"},
        ]
    }

    static async get_quotation_public(invoice_id) {
        let quotation
        await axios({
            method: "get",
            url: process.env.VUE_APP_COMMERCIAL_API + `quotations/${invoice_id}?expand=quotation_lines`,
            headers: {
                'via': 'public',
            }
        })
            .then((response) => {
                quotation = response.data;
            })
            .catch((error) => {
                console.log(error);
            });
        return quotation
    }
}

class QuotationLine {
    constructor() {
    }

    static get_quotation_line_form() {
        return {
            name: null,
            description: null,
            price: 0,
            quantity: 0,
            discount: 0,
            taxes: 0,
            total: 0,
            quotation: null
        }
    }
}

class Invoice {
    constructor() {
    }

    static get_invoice_form() {
        return {
            id: null,
            number: null,
            company: "xxx",
            attention_to: null,
            attention_to_name: null,
            organization: null,
            organization_name: null,
            advancement: "pro_format",
            season: null,
            expiration_days: 30,
            send: false,
            send_date: null,
            expiration_date: null,
            taxes: null,
            delivery_taxes: 20,
            delivery_cost: 0,
            phone: null,
            email: null,
            billing_address: null,
            billing_city: null,
            billing_postal_code: null,
            billing_province: null,
            billing_country: null,
            delivery_address: null,
            delivery_city: null,
            delivery_postal_code: null,
            delivery_province: null,
            delivery_country: null,
            discount: null,
            account_manager: null,
            account_manager_name: null,
            terms_of_sales: null,
            total_discount: 0,
            total_quantity: 0,
            total_taxes: 0,
            subtotal: 0,
            total: 0,
            total_due: 0,
            status: "unpaid",
            delivery_date: null,
            payment_method: null,
            personal_organization_name: null,
            personal_organization_address: null,
            personal_organization_city: null,
            personal_organization_country: null,
            personal_organization_postal_code: null,
            personal_organization_siret: null,
            personal_organization_bic: null,
            personal_organization_iban: null,
            personal_organization_vat_exemption: false,
            person: false,
            my_organization: true,
            expense: false,
            billing_iban: null,
            billing_bic: null,
            ref: null,
            is_periodic: false,
            periodic_date: null,
        }
    }

    static get_season_choices() {
        return [
            {value: "spring", text: "Printemps"},
            {value: "summer", text: "Été"},
            {value: "winter", text: "Hiver"},
            {value: "autumn", text: "Automne"},
        ]
    }

    static get_advancement_choices() {
        return [
            {value: "pro_format", text: "Brouillon"},
            {value: "check", text: "Validé"},
            {value: "consulted", text: "Consultée"},
        ]
    }

    static get_status_choices() {
        return [
            {text: "Payée", value: "paid"},
            {text: "Partiellement payée", value: "partially_paid"},
            {text: "Impayée", value: "unpaid"},
        ]
    }


    static get_payment_method_choices() {
        return [
            {text: "CB", value: "cb"},
            {text: "Chèque", value: "bank_check"},
            {text: "Espèce", value: "cash"},
            {text: "Virement bancaire", value: "bank_transfer"},
        ]
    }

    static async get_invoice_public(invoice_id) {
        let invoice
        await axios({
            method: "get",
            url: process.env.VUE_APP_COMMERCIAL_API + `invoices/${invoice_id}?expand=invoice_lines,invoice_payments`,
            headers: {
                'via': 'public',
            }
        })
            .then((response) => {
                invoice = response.data;
            })
            .catch((error) => {
                console.log(error);
            });
        return invoice
    }

    static async getPdf(invoice_id) {
        let pdfData
        await axios({
            method: "get",
            url: process.env.VUE_APP_COMMERCIAL_API + `invoices/${invoice_id}/get_pdf`,
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('access_token'),
            }
        })
            .then((response) => {
                pdfData = response.data;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
        return pdfData
    }
}

class InvoiceLine {
    constructor() {
    }

    static get_invoice_line_form() {
        return {
            name: null,
            description: null,
            price: 0,
            quantity: 0,
            discount: 0,
            taxes: 0,
            total: 0,
            invoice: null
        }
    }
}

class InvoicePayment {
    constructor() {
    }

    static get_invoice_payment_form(){
        return{
            created_at: new Date(),
            amount: 0,
            note: null,
            payment_method: null,
            invoice: null,
        }
    }
}

class Credit {
    constructor() {
    }

    static get_credit_form() {
        return {
            id: null,
            company: "xxx",
            number: null,
            attention_to: null,
            attention_to_name: null,
            organization: null,
            organization_name: null,
            season: null,
            advancement: "pro_format",
            expiration_days: null,
            send: false,
            send_date: null,
            taxes: null,
            delivery_taxes: 20,
            delivery_cost: 0,
            phone: null,
            email: null,
            billing_address: null,
            billing_city: null,
            billing_postal_code: null,
            billing_province: null,
            billing_country: null,
            delivery_address: null,
            delivery_city: null,
            delivery_postal_code: null,
            delivery_province: null,
            delivery_country: null,
            discount: null,
            account_manager: null,
            account_manager_name: null,
            terms_of_sales: null,
            total_discount: 0,
            total_quantity: 0,
            total_taxes: 0,
            subtotal: 0,
            total: 0,
            delivery_date: null,
            quotation: null,
            personal_organization_name: null,
            personal_organization_address: null,
            personal_organization_city: null,
            personal_organization_country: null,
            personal_organization_postal_code: null,
            personal_organization_siret: null,
            personal_organization_bic: null,
            personal_organization_iban: null,
            personal_organization_vat_exemption: false,
            person: false,
            my_organization: true,
            expense: false,
            billing_iban: null,
            billing_bic: null,
            status: "unpaid",
        }
    }

    static get_season_choices() {
        return [
            {value: "spring", text: "Printemps"},
            {value: "summer", text: "Été"},
            {value: "winter", text: "Hiver"},
            {value: "autumn", text: "Automne"},
        ]
    }

    static get_advancement_choices() {
        return [
            {value: "pro_format", text: "Brouillon"},
            {value: "check", text: "Validé"},
        ]
    }

    static get_status_choices() {
        return [
            {text: "Payée", value: "paid"},
            {text: "Partiellement payée", value: "partially_paid"},
            {text: "Impayée", value: "unpaid"},
        ]
    }

    static async get_credit_public(credit_id) {
        let credit
        await axios({
            method: "get",
            url: process.env.VUE_APP_COMMERCIAL_API + `credits/${credit_id}?expand=credit_lines`,
            headers: {
                'via': 'public',
            }
        })
            .then((response) => {
                credit = response.data;
            })
            .catch((error) => {
                console.log(error);
            });
        return credit
    }
}

class CreditLine {
    constructor() {
    }

    static get_credit_line_form() {
        return {
            name: null,
            description: null,
            price: 0,
            quantity: 0,
            discount: 0,
            taxes: 0,
            total: 0,
            credit: null
        }
    }
}

class CreditPayment {
    constructor() {
    }

    static get_credit_payment_form(){
        return{
            created_at: new Date(),
            amount: 0,
            note: null,
            payment_method: null,
            credit: null,
        }
    }
}

class PersonalOrganization {
    constructor() {
    }

    static get_form_personal_organization() {
        return {
            id: null,
            name: null,
            address: null,
            city: null,
            country: null,
            postal_code: null,
            siret: null,
            bic: null,
            iban: null,
            vat_exemption: false,
        }
    }
}

class Activity {
    constructor() {

    }

    static get_form() {
        return {
            id: null,
            assigned_users: [],
            name: null,
            types: [],
            description: null,
            location: null,
            start: null,
            end: null,
            business_opportunity: null,
            template: null,
            contacts: [],
            assign_person: false,
        }
    }

    static get_types() {
        return [
            {text: "Appel", value: "call"},
            {text: "Rendez-vous", value: "rdv"},
            {text: "Vol", value: "flight"},
            {text: "Repas", value: "lunch"},
        ]
    }
}

class ReportingCrm {
    constructor() {
    }


    static getCategories() {
        return [
            {text: "Ventes", value: "sales"},
            {text: "Achats", value: "expense"},
            {text: "Opportunités", value: "opportunities"},
        ]
    }

    static getInformations() {
        return {
            sales: [
                {
                    value: false,
                    reference: "quotation__accepted",
                    label: "Devis (acceptés)",
                    color: "#62CC91"
                },
                {
                    value: false,
                    reference: "invoice__accepted",
                    label: "Facture (acceptées)",
                    color: "#465BFD"
                },
                {
                    value: false,
                    reference: "purchase_order__accepted",
                    label: "Bon de commande (acceptés)",
                    color: "#FF4247"
                },
                {
                    value: false,
                    reference: "delivery_note__accepted",
                    label: "Bon de livraison (acceptés)",
                    color: "#81E8FF"
                },
                {
                    value: false,
                    reference: "product_return__accepted",
                    label: "Retour produit (acceptés)",
                    color: "#FFC81E"
                },
                {
                    value: false,
                    reference: "refund__accepted",
                    label: "Remboursement (acceptés)",
                    color: "#FA7B1F"
                },
                {
                    value: false,
                    reference: "credit__accepted",
                    label: "Avoir (acceptés)",
                    color: "#3C416B"
                },
                {
                    value: false,
                    reference: "invoice__paid",
                    label: "Factures payées",
                    color: "#767A9E"
                },
            ],
            expense: [
                {
                    value: false,
                    reference: "quotation__accepted",
                    label: "Devis (acceptés)",
                    color: "#62CC91"
                },
                {
                    value: false,
                    reference: "invoice__accepted",
                    label: "Facture (acceptées)",
                    color: "#465BFD"
                },
                {
                    value: false,
                    reference: "purchase_order__accepted",
                    label: "Bon de commande (acceptés)",
                    color: "#FF4247"
                },
                {
                    value: false,
                    reference: "delivery_note__accepted",
                    label: "Bon de livraison (acceptés)",
                    color: "#81E8FF"
                },
                {
                    value: false,
                    reference: "product_return__accepted",
                    label: "Retour produit (acceptés)",
                    color: "#FFC81E"
                },
                {
                    value: false,
                    reference: "refund__accepted",
                    label: "Remboursement (acceptés)",
                    color: "#FA7B1F"
                },
                {
                    value: false,
                    reference: "credit__accepted",
                    label: "Avoir (acceptés)",
                    color: "#3C416B"
                },
                {
                    value: false,
                    reference: "invoice__paid",
                    label: "Factures payées",
                    color: "#767A9E"
                },
            ],
            opportunities: [
                {
                    value: false,
                    reference: "business_opportunity",
                    label: "Opportunités créées",
                    color: "#62CC91"
                },
                // {
                //   value: false,
                //   label: "Nombre d’opportunités ouvertes",
                //   color: "#FF4247"
                // },
                {
                    value: false,
                    reference: "business_opportunity__win",
                    label: "Opportunités gagnées",
                    color: "#465BFD"
                },
                {
                    value: false,
                    reference: "business_opportunity__late",
                    label: "Opportunités en retard",
                    color: "#FF4247"
                },
                {
                    value: false,
                    reference: "business_opportunity__lost",
                    label: "Opportunités perdues",
                    color: "#81E8FF"
                },
            ]
        }
    }
}

class DashboardCrm{
    constructor() {
    }

    static get_filters(){
        return{
            quotations: {
                filters: {
                    quotation__last: {
                        label: "Nouveaux devis",
                        value: false
                    },
                    quotation__expiration_date: {
                        label: "Devis expirés",
                        value: false,
                    },
                    quotation__this_year: {
                        label: "Devis fait cette année",
                        value: false,
                    },
                    quotation__this_month: {
                        label: "Devis fait ce mois",
                        value: false,
                    },
                    quotation__this_weak: {
                        label: "Devis fait cette semaine",
                        value: false,
                    },
                    quotation__this_day: {
                        label: "Devis fait aujourd'hui",
                        value: false,
                    },
                },
                label: "Devis"
            },
            invoices: {
                filters: {
                    invoice__last: {
                        label: "Nouvelles factures",
                        value: false
                    },
                    invoice__expiration_date: {
                        label: "Factures en retard",
                        value: false,
                    },
                    invoice__this_year: {
                        label: "Facturé cette année",
                        value: false,
                    },
                    invoice__this_month: {
                        label: "Facturé ce mois-ci",
                        value: false,
                    },
                    invoice__this_weak: {
                        label: "Facturé cette semaine",
                        value: false,
                    },
                    invoice__this_day: {
                        label: "Facturé aujourd'hui",
                        value: false,
                    },
                    invoice__sale: {
                        label: "Récap factures de vente",
                        value: false,
                    }
                },
                label: "Factures"
            },
            purchase_orders_out: {
                filters: {
                    purchase_order__out: {
                        label: "Nouveaux bons de commande",
                        value: false,
                    }
                },
                label: "Bons de commande"
            },
            purchase_orders_in: {
                filters: {
                    purchase_order__in: {
                        label: "Nouveaux ordres d'achat",
                        value: false,
                    }
                },
                label: "Odres d'achat"
            },
            delivery_note_out: {
                filters: {
                    delivery_note__waiting__out: {
                        label: "Bons de livraison en attente",
                        value: false
                    },
                    delivery_note__ready_to_deliver__out: {
                        label: "Bons de livraison prêt à la livraison",
                        value: false
                    },
                    delivery_note__make_the_delivery__out: {
                        label: "Bons de livraison expédié",
                        value: false
                    }
                },
                label: "Bon de livraison"
            },
            delivery_note_in: {
              filters: {
                delivery_note__waiting__in: {
                      label: "Livraison en attente",
                      value: false,
                  }
              },
              label: "Livraison"
          },
        //     business_opportunity: {
        //         filters: {
        //             business_opportunity__recap: {
        //                 label: "Opportunités",
        //                 value: false,
        //             }
        //         },
        //         label: "Opportunités"
        //     }
        }
    }
}

module.exports.PipelineCrm = PipelineCrm;
module.exports.PipelineTeam = PipelineTeam;
module.exports.StateCrm = StateCrm;
module.exports.BusinessOpportunity = BusinessOpportunity;
module.exports.Quotation = Quotation;
module.exports.QuotationLine = QuotationLine;
module.exports.Invoice = Invoice;
module.exports.InvoiceLine = InvoiceLine;
module.exports.InvoicePayment = InvoicePayment;
module.exports.Credit = Credit;
module.exports.CreditLine = CreditLine;
module.exports.CreditPayment = CreditPayment;
module.exports.PersonalOrganization = PersonalOrganization;
module.exports.Activity = Activity;
module.exports.ReportingCrm = ReportingCrm;
module.exports.DashboardCrm = DashboardCrm;
